import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import SiderTopic from '../../../components/siderTopic';
import Stock from './stock';
import StockInfo from './stockInfo';
import StockSearch from './stockSearch';
import NewsSiderContent from '../../../components/newsSiderContent';
import EditorContent from './editorContent';

class FPNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                fpNewsSiderTitle,
                fpNewsSiderStockImg,
                fpNewsSiderStockSearch,
                fpNewsSiderList,
                fpNewsSiderContent,
            },
        } = this.props;

        return (
            <div className={styles.sider_box}>
                <Chip
                    id="50061"
                    type="struct"
                    title="财经体育要闻区左侧栏标题"
                    groupName="财经体育要闻区左侧栏"
                    content={fpNewsSiderTitle}>
                    <SiderTopic />
                </Chip>
                <div className={styles.stock_box}>
                    <Chip
                        id="50064"
                        type="struct"
                        title="财经左侧栏股票行情图"
                        groupName="财经体育要闻区左侧栏"
                        content={fpNewsSiderStockImg}>
                        <Stock />
                    </Chip>
                    <StockInfo />
                </div>
                <Chip
                    id="50104"
                    type="struct"
                    title="财经左侧栏股票搜索"
                    groupName="财经体育要闻区左侧栏"
                    content={fpNewsSiderStockSearch}>
                    <StockSearch />
                </Chip>
                <div id="financeSiderList" className={styles.sider_list}>
                    <Chip
                        id="75043"
                        type="recommend"
                        title="财经左侧栏凤凰金融内容"
                        groupName="财经体育要闻区左侧栏"
                        content={fpNewsSiderList}
                        translate="handleNewsContentData">
                        <NewsSiderContent />
                    </Chip>
                </div>
                <Chip
                    id="50090"
                    type="struct"
                    title="旅游编辑区"
                    groupName="财经体育要闻区左侧栏"
                    content={fpNewsSiderContent}>
                    <EditorContent />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FPNewsSider);
